<div class="document-body">
    <section class="margin-bottom-10">
        <label class="title-table-style">
            {{ 'cf-document-anonymous.label.greeting' | translate }}
            {{ this.authenticationService.currentUserValue.userResource.userName }}, {{ title }}
        </label>
    </section>
    <section style="height: 100%">
        <kendo-gridlayout [cols]="['100%']" [gap]="10" *ngIf="isDocumentLoaded">
            <kendo-gridlayout-item [col]="1" [row]="1">
                <clfl-document-info-section [document]="document"></clfl-document-info-section>
                <clfl-signatures
                    [unsignedSections]="getUnsignedSection()"
                    [participants]="getSessionParticipant()"
                    [disabled]="!allowSigning"
                    (onSign)="openSignDialog()"
                    (onLoading)="setLoadingState($event)"></clfl-signatures>
            </kendo-gridlayout-item>
        </kendo-gridlayout>
    </section>
</div>

<ng-container *ngIf="isSignWithPinDialogOpened">
    <clfl-sign-with-pin-code
        [document]="document"
        [isOpened]="isSignWithPinDialogOpened"
        (isOpenedChange)="onSearch(); isSignWithPinDialogOpened = $event"
        (confirmAction)="onSearch(); isSignWithPinDialogOpened = false"
        (onLoading)="setLoadingState($event)">
    </clfl-sign-with-pin-code>
</ng-container>

<ng-container *ngIf="isSignOnGlassDialogOpened">
    <clfl-sign-on-glass
        [document]="document"
        [isOpened]="isSignOnGlassDialogOpened"
        (isOpenedChange)="onSearch(); isSignOnGlassDialogOpened = $event"
        (confirmAction)="onSearch(); isSignOnGlassDialogOpened = false"
        (onLoading)="setLoadingState($event)">
    </clfl-sign-on-glass>
</ng-container>

<div class="loader" *ngIf="isLoading">
    <div class="grid-loading-container">
        <kendo-loader type="converging-spinner" themeColor="info" size="medium"> </kendo-loader>
    </div>
</div>
